import styled from 'styled-components';

export const Container = styled.form`
  margin-top: ${({ theme }) => theme.spacing.xlg};
  > *:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.xlg};
  }
`;
